import { HttpStatusCodes } from '@service-initiation/shared-clients-http';
import { LoggerWarning } from '@service-initiation/shared-clients-logger';
import { logger } from '@service-initiation/shared-clients-osp-logger';
import {
  type GetBookingWindowsPayload,
  type GetBookingWindowsResponse,
} from '@service-initiation/shared-clients-tech-care-services';
import { queryClient } from '@service-initiation/shared-utils-query-client';

import { techCareServicesClient } from './clients/techCareServicesClient';

const ExemptErrorMessages = [
  'No operators are in range to service this request',
  'No operators currently have parts available to service this request',
  'No operators currently have availability to service this request',
];

export const getBookingWindows = async (
  payload: GetBookingWindowsPayload
): Promise<GetBookingWindowsResponse> => {
  try {
    const bookingWindowsRes = await queryClient.fetchQuery({
      queryFn: async () => {
        const response = await techCareServicesClient.getBookingWindows({
          quote_data: { ...payload },
        });

        if (response.status !== HttpStatusCodes.OK) {
          throw new Error('Received invalid response status from server.');
        }

        if (
          response.body?.data.error &&
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          !ExemptErrorMessages.includes(response.body.data.error_message!)
        ) {
          logger.warn(
            new LoggerWarning(
              'Failed to get booking windows',
              response.body.data.error_message ||
                'response returned an error with no error_message'
            ),
            {
              payload,
              response: response.body.data,
            }
          );
          throw new Error('failed to call ubif booking-windows api');
        }

        return response.body.data;
      },
      queryKey: ['bookingWindows', payload],
      retry: 2,
      staleTime: Infinity,
    });
    return bookingWindowsRes;
  } catch (e) {
    const err = e as Error;
    err.message = 'Error occurred while trying to fetch Booking Windows.';
    logger.error(err, {
      data: payload,
    });
    throw err;
  }
};
